import { render, staticRenderFns } from "./FlowyBlock.vue?vue&type=template&id=daa06380&lang=html"
import script from "./FlowyBlock.vue?vue&type=script&lang=js"
export * from "./FlowyBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports